import { inject, injectable } from 'inversify';
import { IApiService, DrugGroupFilter, DrugGroupOrderBy, OrderByMode, IDrugGroupService } from '@/interfaces/Services';
import { DrugGroupModel } from '@/models/drug_group';
import { serializeMap } from '@/utils/transformers';
import DependencyIdentifiers from '@/ioc/DependencyIdentifiers';

export type PageDrugResponse = {
  data: DrugGroupModel[],
  meta: { total: number; }
};

@injectable()
export default class DrugGroupService implements IDrugGroupService {
  private _api: IApiService;

  constructor(@inject(DependencyIdentifiers.ApiService) api: IApiService) {
    this._api = api;
  }

  async getMany(
    page: number = 1,
    size: number = 20,
    filter: DrugGroupFilter = {},
    orderBy?: Map<DrugGroupOrderBy, OrderByMode>,
  ): Promise<[DrugGroupModel[], number]> {
    let query = `/drug_groups?size=${size}&page=${page}`;
    query += this.getFilterQueryParams(filter);
    if (orderBy && orderBy.size > 0) {
      query += `&orderBy=${this.serializeOrderBy(orderBy)}`;
    }

    const res = await this._api.get<PageDrugResponse>(query);
    return [res.data, res.meta.total];
  }

  async getById(id: string): Promise<DrugGroupModel> {
    return await this._api
      .get<any>(`/drugs/${id}`)
      .then(res => res.data);
  }

  private getFilterQueryParams(filter: DrugGroupFilter): string {
    let query = '';

    if (!!filter.searchQuery) {
      query += `&searchQuery=${filter.searchQuery}`;
    }

    return query;
  }

  private serializeOrderBy(orderBy: Map<DrugGroupOrderBy, OrderByMode>) {
    return serializeMap(orderBy);
  }
}
